export default __webpack_public_path__ + "static/media/slide-1.73d98062.jpg";